import { render, staticRenderFns } from "./Prizes.vue?vue&type=template&id=6bcce5cc&scoped=true&"
import script from "./Prizes.js?vue&type=script&lang=js&"
export * from "./Prizes.js?vue&type=script&lang=js&"
import style0 from "./Prizes.scss?vue&type=style&index=0&id=6bcce5cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcce5cc",
  null
  
)

export default component.exports